import React, { useContext, useState, useEffect } from "react";

const StateContext = React.createContext();
export function useStateContext() {
  return useContext(StateContext);
}

export default function StateProvider({ children }) {
  const freeshippingRate = 35;
  const shippingRate = 5;
  const [emailInBasket, setEmailInBasket] = useState(null);
  const [basket, setBasket] = useState(
    JSON.parse(localStorage.getItem("basket")) || []
  );
  const [tax, setTax] = useState(0);
  const [taxPrice, setTaxPrice] = useState(0);
  // const [finalPrice, setFinalPrice] = useState(null);
  const [shippingOption, setShipingOption] = useState("Standard");

  const free_shipping = 0;
  const standard_shipping = 5;
  const express_shipping = 20;
  const expedit_shipping = 10;

  const value = {
    basket,
    addToBasket,
    getBasketTotal,
    removeItemFromBasket,
    getBasketQuantity,
    modifyQuantityInBasket,
    addOneItemToBasket,
    removeOneItemToBasket,
    emptyBasket,
    ChangeQuantityToBasket,
    getShipping,
    setTax,
    tax,
    getSubtotal,
    freeshippingRate,
    shippingOption,
    setShipingOption,
    taxPrice,
    setTaxPrice,
    emailInBasket,
    setEmailInBasket,
    shippingRate,
  };

  useEffect(() => {
    localStorage.setItem("basket", JSON.stringify(basket));
  }, [basket]);

  function getSubtotal() {
    let subtotal = basket?.reduce(
      (amount, item) => item.price * item.quantity + amount,
      0
    );
    return subtotal;
  }

  function getShipping() {
    if (getSubtotal() > freeshippingRate) {
      return free_shipping;
    } else {
      return standard_shipping;
    }
    // if (shippingOption === "Free") {
    //   return free_shipping;
    // }
    // if (shippingOption === "Standard") {
    //   return standard_shipping;
    // }
    // if (shippingOption === "Expedit") {
    //   return expedit_shipping;
    // }
    // if (shippingOption === "Express") {
    //   return express_shipping;
    // }
  }

  function getBasketTotal() {
    // console.log("shippingOption", shippingOption);
    let subtotal = getSubtotal();
    // console.log("===== tax", tax);
    // const salesTaxPrice = (subtotal * salesTax).toFixed(2);
    let salesTaxPrice = 0;
    if (tax > 0) {
      // console.log("inside if");
      salesTaxPrice = +subtotal * +tax;
      if (salesTaxPrice !== 0) {
        salesTaxPrice = salesTaxPrice.toFixed(2);
      }
      setTaxPrice(salesTaxPrice);
    }
    // console.log("salesTaxPrice", salesTaxPrice);
    if (subtotal < freeshippingRate) {
      subtotal = parseFloat(subtotal) + shippingRate;
    }
    // subtotal =
    //   parseFloat(subtotal) +
    //   parseFloat(salesTaxPrice) +
    //   parseFloat(getShipping());
    // console.log("total", subtotal);
    // return subtotal.toFixed(2);
    return subtotal;
  }

  function emptyBasket() {
    setBasket([]);
  }
  function addToBasket(item) {
    let found = false;

    basket.map((basketEach) => {
      if (basketEach.id === item.id) {
        found = true;
        let basketQuantity = +basketEach.quantity;
        let quantity = +item.quantity;

        let newBasketEach = {
          ...basketEach,
          quantity: basketQuantity + quantity,
        };

        // let removed = basket.filter((bs) => bs.id !== item.id);
        // setBasket(
        //   (oldArray) => [...removed, newBasketEach],
        //   () => {
        //     localStorage.setItem("basket", JSON.stringify(basket));
        //   }
        // );

        let temp = basket;
        //Find index of specific object using findIndex method.
        let objIndex = temp.findIndex((bs) => bs.id == item.id);
        //Log object to Console.
        console.log("Before update: ", temp[objIndex]);
        //Update object's name property.
        temp[objIndex] = newBasketEach;
        //Log object to console again.
        console.log("After update: ", temp[objIndex]);
        setBasket((old) => [...temp]);
        localStorage.setItem("basket", JSON.stringify(basket));
        console.log("basket after update", basket);
      }
    });
    // window.sessionStorage.setItem("basket", basket);
    if (!found) {
      setBasket((oldArray) => [...oldArray, item]);
    }
  }
  function ChangeQuantityToBasket(id, newQuantity) {
    let res = basket?.map((basketEach) => {
      // console.log(basketEach);
      if (basketEach.id === id) {
        let newBasketEach = {
          ...basketEach,
          quantity: newQuantity,
        };

        let temp = basket;

        //Find index of specific object using findIndex method.
        let objIndex = temp.findIndex((bs) => bs.id == id);
        //Log object to Console.
        console.log("Before update: ", temp);
        //Update object's name property.
        temp[objIndex] = newBasketEach;
        //Log object to console again.
        console.log("After update: ", temp);
        setBasket((old) => [...temp]);
        localStorage.setItem("basket", JSON.stringify(basket));
        console.log("basket after update", basket);
        // let removed = basket.filter((bs) => bs.id !== id);
        // setBasket((oldArray) => [...removed, newBasketEach]);
      }
    });
  }
  function removeOneItemToBasket(id) {
    basket.map((basketEach) => {
      if (basketEach.id === id) {
        let basketQuantity = +basketEach.quantity;
        if (basketQuantity > 1) {
          let newBasketEach = {
            ...basketEach,
            quantity: basketQuantity - 1,
          };

          let removed = basket.filter((bs) => bs.id !== id);
          setBasket((oldArray) => [...removed, newBasketEach]);
        }
      }
    });
  }
  function addOneItemToBasket(id) {
    basket.map((basketEach) => {
      if (basketEach.id === id) {
        let basketQuantity = +basketEach.quantity;

        let newBasketEach = {
          ...basketEach,
          quantity: basketQuantity + 1,
        };

        let removed = basket.filter((bs) => bs.id !== id);
        setBasket((oldArray) => [...removed, newBasketEach]);
      }
    });
  }
  function modifyQuantityInBasket(id, quantity) {
    let found = false;
    basket.map((basketEach) => {
      if (basketEach.id === id) {
        found = true;
        let newBasketEach = { ...basketEach, quantity: quantity };
        let removed = basket.filter((bs) => bs.id !== id);
        setBasket((oldArray) => [...removed, newBasketEach]);
      }
    });
  }
  function getBasketQuantity() {
    console.log("basket in context", basket);

    let total = basket?.reduce(function (prev, current) {
      return prev + +current.quantity;
    }, 0);
    return total;
    // return basket?.reduce((amount, item) => item.quantity + amount, 0);
  }

  function removeItemFromBasket(id) {
    let removed = basket?.filter((basketEach) => id !== basketEach.id);
    setBasket((oldArray) => removed);
  }

  return (
    <StateContext.Provider value={value}>{children}</StateContext.Provider>
  );
}
